import React from 'react'

type SvgTProps = {
    className?: string
    onClick?: any
}

export const StarSvg = ({className, onClick}: SvgTProps): JSX.Element => {
    return (
        <svg xmlns="http://www.w3.org/1999/xlink"
             version="1.1"
             x="0px"
             y="0px"
             viewBox="0 0 47.94 47.94"
             className={className}
             onClick={onClick}
        >
            <path fill="currentColor"
                  d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757  c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042  c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685  c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528  c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956  C22.602,0.567,25.338,0.567,26.285,2.486z"
            />
        </svg>
    )
}

export const ForkSvg = ({className, onClick}: SvgTProps): JSX.Element => {
    return (
        <svg version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             x="0px"
             y="0px"
             viewBox="0 0 512 512"
             className={className}
             onClick={onClick}
        >
            <g id="XMLID_2_">
                <path id="XMLID_8_"
                      fill="currentColor"
                      d="M181.8,448c0-8.5-3.4-16.2-9.4-23c-6-6.8-13.7-9.4-23-9.4s-16.2,3.4-23,9.4c-6,6-9.4,13.7-9.4,23s3.4,16.2,9.4,23c6,6,13.7,9.4,23,9.4s16.2-3.4,23-9.4S181.8,456.5,181.8,448z M181.8,64c0-8.5-3.4-16.2-9.4-23c-6-6-13.7-9.4-23-9.4s-16.2,3.4-23,9.4c-6,6-9.4,13.7-9.4,23c0,8.5,3.4,16.2,9.4,23c6,6,13.7,9.4,23,9.4s16.2-3.4,23-9.4C179.2,81.1,181.8,72.5,181.8,64z M395.1,106.7c0-8.5-3.4-16.2-9.4-23c-6-6.8-13.7-9.4-23-9.4s-16.2,3.4-23,9.4c-6.8,6-9.4,13.7-9.4,23s3.4,16.2,9.4,23c6,6,13.7,9.4,23,9.4s16.2-3.4,23-9.4C391.7,122.9,395.1,115.2,395.1,106.7z M426.7,106.7c0,11.9-2.6,22.2-8.5,32.4s-13.7,17.9-23,23c-0.9,64-25.6,110.1-75.1,138.2c-15.4,8.5-37.5,17.1-67.4,27.3c-28.2,8.5-46.9,17.1-56.3,23.9c-9.4,6.8-13.7,17.9-13.7,33.3v8.5c9.4,6,17.9,13.7,23,23c5.1,9.4,8.5,20.5,8.5,32.4c0,17.9-6,33.3-18.8,45.2S167.3,512,149.3,512s-33.3-6-45.2-18.8c-11.9-12.8-18.8-27.3-18.8-45.2c0-11.9,2.6-22.2,8.5-32.4c6-10.2,13.7-17.9,23-23V119.5c-9.4-6-17.9-13.7-23-23S85.3,75.9,85.3,64c0-17.9,6-33.3,18.8-45.2S131.4,0,149.3,0s33.3,6,45.2,18.8c11.9,12.8,18.8,27.3,18.8,45.2c0,11.9-2.6,22.2-8.5,32.4s-13.7,17.9-23,23V285c11.9-6,29-11.9,51.2-18.8c11.9-3.4,22.2-6.8,29-10.2c6.8-3.4,15.4-6,23.9-10.2s15.4-8.5,19.6-12.8s9.4-10.2,13.7-17.1s7.7-14.5,9.4-23c1.7-8.5,2.6-18.8,2.6-30.7c-9.4-6-17.9-13.7-23-23s-8.5-20.5-8.5-32.4c0-17.9,6-33.3,18.8-45.2c12.8-12.8,27.3-18.8,45.2-18.8s33.3,6,45.2,18.8C420.7,73.4,426.7,88.7,426.7,106.7z"
                />
            </g>
        </svg>

    )
}

export const WatchersSvg = ({className, onClick}: SvgTProps): JSX.Element => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             version="1.1"
             viewBox="0 0 512 512"
             className={className}
             onClick={onClick}
        >
            <g>
                <path fill="currentColor"
                      d="m496.4,243.1c-63.9-78.7-149.3-122.1-240.4-122.1-91.1,0-176.5,43.4-240.4,122.1-6.1,7.5-6.1,18.2 0,25.7 63.9,78.8 149.3,122.2 240.4,122.2 91.1,0 176.5-43.4 240.4-122.1 6.1-7.5 6.1-18.3 0-25.8zm-240.4,79.8c-36.9,0-66.9-30-66.9-66.9 0-36.9 30-66.9 66.9-66.9 36.9,0 66.9,30 66.9,66.9 0,36.9-30,66.9-66.9,66.9zm-197.8-66.9c37.8-42.2 82.9-71.1 131.5-84.9-25.2,19.7-41.5,50.4-41.5,84.9 0,34.4 16.2,65.1 41.5,84.9-48.6-13.8-93.6-42.7-131.5-84.9zm264.1,84.9c25.2-19.7 41.5-50.4 41.5-84.9 0-34.4-16.2-65.1-41.5-84.9 48.6,13.8 93.7,42.7 131.5,84.9-37.9,42.2-82.9,71.1-131.5,84.9z"
                />
            </g>
        </svg>

    )
}

export const ShoppingCartSvg = ({className, onClick}: SvgTProps): JSX.Element => {
    return (
        <svg version="1.1"
             id="Layer_1"
             xmlns="http://www.w3.org/2000/svg"
             x="0px"
             y="0px"
             viewBox="0 0 122.9 107.5"
             className={className}
             onClick={onClick}
        >
            <g>
                <path fill="currentColor"
                      d="M3.9,7.9C1.8,7.9,0,6.1,0,3.9C0,1.8,1.8,0,3.9,0h10.2c0.1,0,0.3,0,0.4,0c3.6,0.1,6.8,0.8,9.5,2.5c3,1.9,5.2,4.8,6.4,9.1 c0,0.1,0,0.2,0.1,0.3l1,4H119c2.2,0,3.9,1.8,3.9,3.9c0,0.4-0.1,0.8-0.2,1.2l-10.2,41.1c-0.4,1.8-2,3-3.8,3v0H44.7 c1.4,5.2,2.8,8,4.7,9.3c2.3,1.5,6.3,1.6,13,1.5h0.1v0h45.2c2.2,0,3.9,1.8,3.9,3.9c0,2.2-1.8,3.9-3.9,3.9H62.5v0 c-8.3,0.1-13.4-0.1-17.5-2.8c-4.2-2.8-6.4-7.6-8.6-16.3l0,0L23,13.9c0-0.1,0-0.1-0.1-0.2c-0.6-2.2-1.6-3.7-3-4.5 c-1.4-0.9-3.3-1.3-5.5-1.3c-0.1,0-0.2,0-0.3,0H3.9L3.9,7.9z M96,88.3c5.3,0,9.6,4.3,9.6,9.6c0,5.3-4.3,9.6-9.6,9.6 c-5.3,0-9.6-4.3-9.6-9.6C86.4,92.6,90.7,88.3,96,88.3L96,88.3z M53.9,88.3c5.3,0,9.6,4.3,9.6,9.6c0,5.3-4.3,9.6-9.6,9.6 c-5.3,0-9.6-4.3-9.6-9.6C44.3,92.6,48.6,88.3,53.9,88.3L53.9,88.3z M33.7,23.7l8.9,33.5h63.1l8.3-33.5H33.7L33.7,23.7z"
                />
            </g>
        </svg>
    )
}

export const ArrowSvg = ({className, onClick}: SvgTProps): JSX.Element => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 30.125 18.1738"
             className={className}
             onClick={onClick}
        >
            <path
                d="M29.75,9.3948,21.5281,1.1735a.8479.8479,0,0,0-.601-.261L20.9124.9119a.8526.8526,0,0,0-.5956.2409.8642.8642,0,0,0-.0027,1.23l6.7618,6.7611H.7316a.8566.8566,0,1,0,0,1.7131H27.0759l-6.7591,6.7591a.8576.8576,0,0,0-.0214,1.2113.8462.8462,0,0,0,.61.2583.8949.8949,0,0,0,.621-.2556l8.2233-8.224A.8587.8587,0,0,0,29.75,9.3948Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const CloseSvg = ({className, onClick}: SvgTProps): JSX.Element => {
    return (
        <svg version="1.1"
             viewBox="0 0 512 512"
             xmlns="http://www.w3.org/2000/svg"
             className={className}
             onClick={onClick}
        >
            <path fill="currentColor"
                d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
            />
        </svg>
    )
}
